
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 29 28","fill":"#282828","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"opacity":".6"}},[_c('path',{attrs:{"d":"M23.195 3.281h-1.64v.82a2.464 2.464 0 01-2.461 2.462H10.89A2.464 2.464 0 018.43 4.101v-.82H6.79a2.464 2.464 0 00-2.462 2.46V25.43c0 1.357 1.104 2.57 2.461 2.57h16.406c1.357 0 2.461-1.213 2.461-2.57V5.742a2.464 2.464 0 00-2.46-2.46zm-9.264 17.807l-3.28 3.281a.818.818 0 01-1.16 0l-1.641-1.64a.82.82 0 111.16-1.16l1.06 1.06 2.702-2.701a.82.82 0 111.16 1.16zm0-5.742l-3.28 3.28a.818.818 0 01-1.16 0l-1.641-1.64a.82.82 0 111.16-1.16l1.06 1.06 2.702-2.7a.82.82 0 111.16 1.16zm0-5.743l-3.28 3.282a.818.818 0 01-1.16 0L7.85 11.244a.82.82 0 111.16-1.16l1.06 1.06 2.702-2.7a.82.82 0 111.16 1.16zm7.624 13.366h-4.922a.82.82 0 110-1.64h4.922a.82.82 0 110 1.64zm0-5.742h-4.922a.82.82 0 110-1.641h4.922a.82.82 0 110 1.64zm0-5.743h-4.922a.82.82 0 110-1.64h4.922a.82.82 0 110 1.64z"}}),_c('path',{attrs:{"d":"M18.273 1.64h-1.54l-.193-.546A1.646 1.646 0 0014.992 0c-.694 0-1.315.44-1.548 1.094l-.193.547h-1.54a1.64 1.64 0 00-1.64 1.64v.82c0 .454.367.82.82.82h8.203a.82.82 0 00.82-.82v-.82a1.64 1.64 0 00-1.64-1.64z"}})])])
          )
        }
      }
    